import Editor from '@monaco-editor/react';

/**
 * Read-only code editor (Monaco) — used to display generated / compiled code
 * with syntax highlighting + line numbers (the same editor platform-app used
 * for compiled taskflow code). Defaults to JavaScript + the dark theme to match
 * the console. Not for editing — pass editable code through a node-config form.
 */
export function CodeViewer({
  code,
  language = 'javascript',
  height = 320,
}: {
  code: string;
  language?: string;
  height?: number | string;
}) {
  return (
    <div
      style={{
        border: '1px solid var(--border-subtle)',
        borderRadius: 4,
        overflow: 'hidden',
      }}
    >
      <Editor
        height={height}
        defaultLanguage={language}
        value={code}
        theme="vs-dark"
        options={{
          readOnly: true,
          domReadOnly: true,
          minimap: { enabled: false },
          fontSize: 12,
          lineNumbers: 'on',
          renderLineHighlight: 'none',
          scrollBeyondLastLine: false,
          wordWrap: 'on',
          automaticLayout: true,
          scrollbar: { alwaysConsumeMouseWheel: false },
        }}
      />
    </div>
  );
}
